import { memo } from "react";
import { TableItemId } from "../../../../../components/tables/TableWidget";
import ActionMenu from "../../../../../components/actionMenu/ActionMenu";
import { TableItemType } from "../../../../../components/tables/tableContext/TableContext";
import { expeditionRoutes } from "../../../../../router/routesConstants";
import { ScheduleWorkingRoutesListInterface } from "../../../../../redux/interfaces/expedition.interface";

function ExpeditionScheduleWorkingRoutesTableActionButtons({
  itemId,
  crudData,
}: {
  itemId: TableItemId;
  tableItemData: TableItemType[];
  crudData?: ScheduleWorkingRoutesListInterface;
  tableContext?: any;
}) {
  const goToOrganizeWorkingPoint = () => {
    return `/${expeditionRoutes.routesOrganizationLocal}/${expeditionRoutes.organize}?id=${itemId}&denumire=${crudData?.denumire}&cod=${crudData?.cod}`;
  };

  return (
    <ActionMenu
      items={[
        {
          id: "organize-route",
          label: "Organizeaza ruta",
          icon: "DOCUMENTS",
          tooltip: "Deschide organizarea punctelor de lucru pe aceasta ruta.",
          navigate: goToOrganizeWorkingPoint(),
        },
      ]}
      minItemsForMenu={2}
      title={crudData?.denumire}
      ariaLabel={`Actiuni pentru ruta ${crudData?.denumire ?? ""}`}
    />
  );
}

export default memo(ExpeditionScheduleWorkingRoutesTableActionButtons);
